const loginAndSignUp = {
  loginTips: "HitPawのアカウントをお持ちですか？<1>ログイン</1>",
  loginSuccessTips: "ログインに成功しました。",
  loginErrorTips: "ログインに失敗しました。",
  loginAccountOrPasswordErrorTips: "メールアドレスまたはパスワードが間違っていました。もう一度やり直してください。",
  loginAccountNotExitErrorTips: "このメールアドレスが登録されていません",
  signUpTips: "また登録していませんか？",
  rememberMe: "ログインしたままにする",
  forgotPassword: "パスワードが忘れた場合",
  forgotPasswordTitle: "パスワードが忘れた",
  verifyEmailBtn: "メール認証",
  resetPasswordTitle: "パスワードを再設定する",
  resetPasswordLabel: "パスワードを再設定してください",
  resetPasswordPlaceholder: "新しいパスワードを入力してください",
  resetPasswordSuccessTips: "パスワードの変更に成功しました",
  signUpPrivacyTips: "HitPawに登録することで、当社の<1>利用規約</1>および<3>プライバシーポリシー</3>に同意したものとします。",
  loginPrivacyTips: "HitPawにログインすることで、当社の<1>利用規約</1>および<3>プライバシーポリシー</3>に同意したものとします。",
  signUpSuccessTips: "アカウントが正常に登録されました！",
  getCode: "コードを取得",
  getCodeSuccessTips: "指定したメールアドレスに送信しました。受信トレイをご確認ください。",
  verificationSuccessTips: "メールアドレスの認証に成功しました",
  surveyTitle: "HitPawへようこそ",
  surveyStep1: "<1>ステップ1</1>",
  surveyStep2: "<1>ステップ2</1>",
  surveyStep3: "<1>ステップ3</1>",
  surveyQuestion: "HitPawを使用する目的は何ですか？",
  surveyThemeQuestion: "好きなモードを選択してください",
  surveyAnswerOther: "その他",
  surveyAnswer1: "ライフスタイルビデオ",
  surveyAnswer2: "ビジネスビデオ",
  surveyAnswer3: "会社ビデオ",
  surveyAnswer4: "動画マーケティング",
  surveyAnswer5: "ソーシャルメディアビデオ",
  surveyAnswer6: "スライドショービデオ",
  surveyAnswer7: "ビデオツール",
  surveyAnswer8: "旅行ビデオ",
  surveyAnswer9: "結婚式ビデオ",
  surveyAnswer10: "誕生日ビデオ",
  surveyAnswer11: "ベビービデオ",
  surveyAnswer12: "動物ビデオ",
  surveyAnswer13: "美食ビデオ",
  surveyAnswer14: "ファッションビデオ",
  surveyAnswer15: "ホリデービデオ",
  surveyAnswer16: "スポーツビデオ",
  surveyAnswer17: "写真ビデオ",
  surveyAnswer18: "音楽ビデオ",
  surveyAnswerLightMode: "ライトモード",
  surveyAnswerDarkMode: "ダークモード",
  surveyNextBtn: "次",
  surveyBackBtn: "戻る",
  surveyDoneBtn: "完了",
  surveyStartBtn: "スタート",
  logoutWarnTips: "ログアウトしてもよろしいですか？",
};

export default loginAndSignUp;
